'use client'

import { Clipboard } from '@/components/common/Clipboard'
import { IconAdvanced } from '@/components/icons/IconAdvanced'
import { useReduxDispatch, useReduxSelector } from '@/store/hooks'
import { viewActions } from '@/store/view'

import { SidebarRoot } from '../SidebarRoot/SidebarRoot'

export const SidebarClipboard = () => {
  const dispatch = useReduxDispatch()
  const status = useReduxSelector((s) => s.view.clipboardStatus)

  const onClickClose = () => dispatch(viewActions.collapseClipboard())
  const onClickLock = () => dispatch(viewActions.toggleClipboardLock())

  return (
    <SidebarRoot
      iconElement={<IconAdvanced.Clipboard />}
      onClickClose={onClickClose}
      onClickLock={onClickLock}
      position='right'
      sidebar='clipboard'
      status={status}
      title='Clipboard'
    >
      <Clipboard isOpen={status !== 'collapsed'} />
    </SidebarRoot>
  )
}
